import { render, staticRenderFns } from "./BaseInfoCardMarker.vue?vue&type=template&id=53dde966&scoped=true"
import script from "./BaseInfoCardMarker.vue?vue&type=script&lang=js"
export * from "./BaseInfoCardMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dde966",
  null
  
)

export default component.exports